const notificationConfig = {
  // application: {
  //   getNotificationHeading: (notification) => `Application Status`,
  //   getNotificationText: (notification) => `Application has been received`,
  //   getLink: (notification) => {
  //     if (notification && notification['client__id']) {
  //       return `/client/${notification['client__id']}?tab=2`;
  //     } else {
  //       return `/application`;
  //     }
  //   },
  //   icon: <Icon.Clipboard className="font-medium-5 primary" size={21} />,
  // },
  new_user_enroll_notification: {
    getLink: (data) => `/course/lesson/${data?.object_slug}`,
  },
  comment_report: {
    getLink: () => `/`,
  },
  contact_enquiry: {
    getLink: () => `/dashboard/contact-inquiry`,
  },
  course_enroll: {
    getLink: (data) => `/dashboard/courses/course-list/${data?.object_slug}`,
  },
  course_review: {
    getLink: (data) => `/dashboard/courses/course-list/${data?.object_slug}?tab=6`,
  },
  doubt_report: {
    //todo
    // getLink: () => `/dashboard/doubts/reports`,
    getLink: (data) =>
      // data?.object_type === "course" ?
      //   `dashboard/courses/course-list/${data?.object_slug}`
      //   : `dashboard/courses/course-list/${data?.object_slug}?tab=4&subtab=2`,
      `/dashboard/doubts/reports`
  },
  email: {
    getLink: () => `/`,
  },
  member_add_room: {
    getLink: (data) => `/room/${data?.object_slug}`,
  },
  notification_comment_course_post: {
    getLink: (data) => `/doubts/${data?.oid}`,
  },
  notification_like_course_post: {
    getLink: (data) => `/doubts/${data?.oid}`,
  },
  notification_like_room_post: {
    getLink: (data) => `/room/${data?.object_slug}`,
  },
  notification_like_room_comment: {
    getLink: (data) => `/room/${data?.object_slug}`,
  },
  notification_like_course_comment: {
    getLink: (data) => `/course/lesson/${data?.object_slug}`,
  },
  notification_comment_room_post: {
    getLink: (data) => `/course/lesson/${data?.object_slug}`,
  },
  notification_new_instructor_signup: {
    getLink: (data) => `/dashboard/users/instructor/${data?.object_id}`,
  },
  notification_new_review_course: {
    getLink: (data) => `/dashboard/courses/course-list/${data?.object_slug}`,
  },
  notify_instructor_on_question_add_course: {
    //todo
    getLink: (data) => `/dashboard/courses/course-list/${data?.object_slug}`,
  },
  requestcourse: {
    getLink: () => `/dashboard/courses/course-request`,
  },
  // room_discussion_post_create: {
  //   getLink: (data) => `/room/${data?.object_slug}`,
  // },
  room_discussion_post_create: {
    // getLink: (data) => `/doubts/${data?.object_id}`,
    getLink: (data) => `/room/${data?.object_slug}`,
  },
  room_invite_user: {
    getLink: (data) => `/room/${data?.object_slug}`,
  },
  tutor_review: {
    getLink: (data) => {
      // return `/tutor/verify`;
      return `/dashboard/users/instructor/${data?.object_id}`;
    },
  },
  tutor_approve: {
    getLink: (notification) => {
      return `/profile`;
    },
  },
  tutor_reject: {
    getLink: (notification) => {
      return `/profile`;
    },
  },
  user: {
    getLink: (data) => {
      return `/dashboard/users/${data.user}`;
    },
  },
  notify_user_on_instructor_reply_to_question: {
    getLink: (data) => {
      return `/posts/${data?.object_id}`;
    },
  },
  notification_announcement_post: {
    getLink: (data) => {
      return `/room/${data?.object_slug}`;
    },
  },
  notification_accept_invite: {
    getLink: (data) => {
      return `/room/${data?.object_slug}`;
    },
  },
  notification_reject_invite: {
    getLink: (data) => {
      return `/room/${data?.object_slug}`;
    },
  },
  // assessment
  notification_assesment_post: {
    getLink: (data) => {
      return `/room/${data?.object_slug}/assessment/${data?.object_id}`;
    },
  },
  notification_assessment_submission: {
    getLink: (data) => {
      return `/room/${data?.object_slug}/assessment/${data?.object_id}/dashboard`;
    },
  },
  notification_assesment_feedback: {
    getLink: (data) => {
      return `/room/${data?.object_slug}/assessment/${data?.object_id}/dashboard`;
    },
  },
  notification_assesment_feedback_question: {
    getLink: (data) => {
      return `/room/${data?.object_slug}/assessment/${data?.object_id}`;
    },
  },
  notification_assesment_feedback_answer: {
    getLink: (data) => {
      return `/room/${data?.object_slug}/assessment/${data?.object_id}`;
    },
  },
};

export default notificationConfig;
